import React, { useState } from 'react';
import RightSidebarContactForm from '~apartments/components/RightSidebarContactForm';
import ObjectDetailsWithGallery, {
  Props as ObjectDetailsWithGalleryProps,
} from '~components/ObjectDetailsWithGallery';
import {
  postPreviewContactForm,
  postGetPresentationForm,
  postMoreInfoForm,
} from '~src/api/post';
import ModalContactForm from '~components/ModalContactForm';
import ModalHeading from '~components/ContactForm/components/ModalHeading';
import { SubmitSuccessMessage } from '~components/ContactForm/styledComponents';
import { ContactFormFieldNames } from '~utils/hooks/useContactForm';
import { SubmitSuccessMessage as ApartmentsSubmitSuccessMessage } from '~apartments/components/ContactForm/styledComponents';
import {
  ButtonsBlock,
  GreenButton,
  BlueButton,
  BottomButtonWrapper,
  LearnDiscountsText,
  ObjectPageLink,
} from './styledComponents';
import { COMPONENT_IDS } from '~src/constants';
import { getUiIds, uiIdsConcat } from '~contextProviders/uiIds/helpers';
import { ComponentIdContextProvider } from '~contextProviders/uiIds/ComponentIdContextProvider';

const PREVIEW_FORM_FIELD_NAMES: ContactFormFieldNames[] = [
  'name',
  'phone',
  'date',
];
const PRESENTATION_FORM_FIELD_NAMES: ContactFormFieldNames[] = [
  'phone',
  'email',
];

type FormDataType = Record<ContactFormFieldNames, string>;

type Props = Omit<ObjectDetailsWithGalleryProps, 'footerElem'> & {
  formView?: 'sidebar' | 'modal';
  bottomButton?: 'objectPageLink' | 'discount';
};

const ObjectDetailsWithGalleryAndPreviewButtons = ({
  formView = 'modal',
  bottomButton,
  ...objectDetailsProps
}: Props) => {
  const componentId = COMPONENT_IDS.ObjectDetailsWithGalleryAndPreviewButtons;
  const uiIds = uiIdsConcat(getUiIds(), { componentId });

  const { data, desktopSmallView } = objectDetailsProps;
  const { id_crm, url } = data;

  const [showPreviewForm, setShowPreviewForm] = useState(false);
  const [showDiscountsForm, setShowDiscountsForm] = useState(false);
  const [showPresentationForm, setShowPresentationForm] = useState(false);

  const togglePreviewForm = () => setShowPreviewForm((prev) => !prev);
  const togglePresentationForm = () => setShowPresentationForm((prev) => !prev);
  const toggleDiscountsForm = () => setShowDiscountsForm((prev) => !prev);

  console.log('URL', url, objectDetailsProps)

  const objectPageURL = `https://www.mcity.ru/object/${url}`;

  const isModalFormView = formView === 'modal';
  const isSidebarFormView = formView === 'sidebar';

  const postPreviewForm = (formData: FormDataType) =>
    postPreviewContactForm({
      data: {
        ...formData,
        idd: id_crm,
        uiIds,
      },
      url,
    });

  const postPresentationForm = (formData: FormDataType) =>
    postGetPresentationForm({
      data: {
        ...formData,
        idd: id_crm,
        uiIds,
      },
      url,
    });

  const postDiscountsForm = (formData: FormDataType) =>
    postMoreInfoForm({
      data: {
        ...formData,
        idd: id_crm,
        uiIds,
      },
    });

  const footerElem = (
    <>
      <ButtonsBlock desktopSmallView={desktopSmallView}>
        <GreenButton
          desktopSmallView={desktopSmallView}
          onClick={togglePreviewForm}
        >
          Записаться на просмотр
        </GreenButton>
        <BlueButton
          desktopSmallView={desktopSmallView}
          onClick={togglePresentationForm}
        >
          Получить PDF на почту
        </BlueButton>
      </ButtonsBlock>
      {bottomButton === 'objectPageLink' && (
        <BottomButtonWrapper>
          <ObjectPageLink href={objectPageURL} target='_blank'>
            Перейти на страницу объекта
          </ObjectPageLink>
        </BottomButtonWrapper>
      )}
      {bottomButton === 'discount' && (
        <BottomButtonWrapper>
          <LearnDiscountsText onClick={toggleDiscountsForm}>
            Узнать о скидках
          </LearnDiscountsText>
        </BottomButtonWrapper>
      )}
      {isModalFormView && (
        <ModalContactForm
          show={showPreviewForm}
          onClose={togglePreviewForm}
          columnBreakpoint='1080px'
          fieldNames={PREVIEW_FORM_FIELD_NAMES}
          postFn={postPreviewForm}
          heading={
            <ModalHeading
              titleText='Хотите записаться на просмотр?'
              actionText='Заполните поля ниже и мы Вам перезвоним.'
            />
          }
          formId='ga_sign_up_to_view'
        />
      )}
      {isSidebarFormView && (
        <RightSidebarContactForm
          isOpen={showPreviewForm}
          onClose={togglePreviewForm}
          fieldNames={PREVIEW_FORM_FIELD_NAMES}
          titleElem={<div>Хотите записаться на просмотр?</div>}
          descriptionElem={<div>Заполните поля ниже и мы Вам перезвоним.</div>}
          postFn={postPreviewForm}
        />
      )}
      {isModalFormView && (
        <ModalContactForm
          show={showPresentationForm}
          onClose={togglePresentationForm}
          columnBreakpoint='1080px'
          fieldNames={PRESENTATION_FORM_FIELD_NAMES}
          postFn={postPresentationForm}
          heading={
            <ModalHeading
              titleText='Хотите получить презентацию объекта на почту?'
              actionText='Заполните поля ниже и получите презентацию на Вашу электронную почту'
            />
          }
          sumbitSuccessComponent={
            <SubmitSuccessMessage>
              Пожалуйста, проверьте почту, мы выслали Вам презентацию.
            </SubmitSuccessMessage>
          }
          formId='ga_form_get_pdf'
        ></ModalContactForm>
      )}
      {isSidebarFormView && (
        <RightSidebarContactForm
          isOpen={showPresentationForm}
          onClose={togglePresentationForm}
          fieldNames={PRESENTATION_FORM_FIELD_NAMES}
          sumbitSuccessElem={
            <ApartmentsSubmitSuccessMessage>
              Пожалуйста, проверьте почту, мы выслали Вам презентацию.
            </ApartmentsSubmitSuccessMessage>
          }
          titleElem={<div>Хотите получить презентацию объекта на почту?</div>}
          descriptionElem={
            <div>
              Заполните поля ниже и получите презентацию на Вашу электронную
              почту
            </div>
          }
          postFn={postPresentationForm}
        />
      )}
      {bottomButton === 'discount' && (
        <RightSidebarContactForm
          isOpen={showDiscountsForm}
          onClose={toggleDiscountsForm}
          fieldNames={['phone', 'name']}
          titleElem={<div>Получить информацию об акциях в Москва-Сити</div>}
          descriptionElem={<div>Заполните поля ниже и мы Вам перезвоним.</div>}
          postFn={postDiscountsForm}
        />
      )}
    </>
  );

  return (
    <ComponentIdContextProvider componentId={componentId}>
      <ObjectDetailsWithGallery
        footerElem={footerElem}
        data={data}
        {...objectDetailsProps}
      />
    </ComponentIdContextProvider>
  );
};

export default ObjectDetailsWithGalleryAndPreviewButtons;
